import React, {useEffect, useState} from "react";
import {BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid} from "recharts";
import axiosInstance from "../../../AxiosInstance";

export default function DashboardProductionHistogram({variable_data_id, widget_name, sampling}) {
    const [productionData, setProductionData] = useState(null);
    const [period, setPeriod] = useState('7d');

    // sampling: 0=7d, 1=30d, 2=monthly
    useEffect(() => {
        const periodMap = {0: '7d', 1: '30d', 2: 'monthly'};
        setPeriod(periodMap[sampling] || '7d');
    }, [sampling]);

    useEffect(() => {
        if (variable_data_id) {
            axiosInstance.get(`variable_data/${variable_data_id}/production_histogram/?period=${period}`)
                .then(res => setProductionData(res.data))
                .catch(() => setProductionData(null));
        }
    }, [variable_data_id, period]);

    const chartData = (() => {
        if (!productionData) return [];
        const mainData = productionData.data || [];
        const pairedData = productionData.paired_data || [];
        const mainRole = productionData.role || 'good';
        const pairedRole = productionData.paired_role;

        if (!pairedData.length) {
            return mainData.map(d => ({...d, [mainRole]: d.value}));
        }

        const dateMap = {};
        mainData.forEach(d => {
            dateMap[d.date] = {...d, [mainRole]: d.value};
        });
        pairedData.forEach(d => {
            if (dateMap[d.date]) {
                dateMap[d.date][pairedRole] = d.value;
            } else {
                dateMap[d.date] = {date: d.date, day_label: d.day_label, [pairedRole]: d.value};
            }
        });
        return Object.values(dateMap).sort((a, b) => a.date.localeCompare(b.date));
    })();

    return (
        <div style={{width: '100%', height: '100%', padding: '12px', backgroundColor: '#FFF', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)', border: '1px solid #e2e8f0', fontFamily: 'Poppins'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
                <div style={{fontSize: '14px', fontWeight: 600, color: '#334155'}}>{widget_name}</div>
                <div style={{display: 'flex', gap: '8px'}}>
                    {['7d', '30d', 'monthly', 'yearly'].map(p => (
                        <span key={p} onClick={() => setPeriod(p)} style={{
                            cursor: 'pointer', fontWeight: period === p ? 700 : 400,
                            fontSize: '11px', color: period === p ? '#4F46E5' : '#94A3B8'
                        }}>{p === '7d' ? '7d' : p === '30d' ? '30d' : p === 'monthly' ? 'Monthly' : 'Yearly'}</span>
                    ))}
                </div>
            </div>
            {chartData.length > 0 ? (
                <ResponsiveContainer width="100%" height="85%">
                    <BarChart data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9"/>
                        <XAxis dataKey="day_label" tick={{fontSize: 10}}/>
                        <YAxis tick={{fontSize: 10}}/>
                        <Tooltip/>
                        <Legend/>
                        <Bar dataKey="good" fill="#22c55e" radius={[3, 3, 0, 0]} name="Good"/>
                        <Bar dataKey="bad" fill="#ef4444" radius={[3, 3, 0, 0]} name="Bad"/>
                    </BarChart>
                </ResponsiveContainer>
            ) : (
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80%', color: '#94A3B8', fontSize: '13px'}}>
                    No production data yet
                </div>
            )}
        </div>
    );
}
